interface TooltipEntry {
  name: string;
  value: number;
}

interface ChartToolTipProps {
  customLabel?: string;
  data: TooltipEntry[];
}

const getTextColor = (name: string) => {
  switch (name) {
    case 'Fail':
      return 'text-fail';
    case 'Alert':
      return 'text-alert';
    case 'Pass':
      return 'text-pass';
    case 'N/A':
      return 'text-na';
    default:
      return 'text-gray-700';
  }
};

const ChartToolTip: React.FC<ChartToolTipProps> = ({ customLabel, data }) => {
  const isEmpty = !data || data.length === 0;

  return (
    <div className="w-max rounded border border-gray-200 bg-white p-2 text-sm text-gray-800 shadow">
      <div className="mb-1 text-left text-base font-bold text-mainblue">
        {customLabel}
      </div>
      {isEmpty ? (
        <div className="text-na text-sm font-medium">N/A</div>
      ) : (
        data.map((entry, i) => (
          <div
            key={i}
            className={`flex items-center gap-2 ${getTextColor(entry.name)}`}
          >
            <span className="text-sm font-medium">{entry.name}</span>
            <span className="text-base font-bold">{entry.value}</span>
            <span className="text-sm">reports</span>
          </div>
        ))
      )}
    </div>
  );
};

export default ChartToolTip;
